import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SalaryRangeItem } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-salary-card',
    templateUrl: './salary-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule]
})
export class SalaryCardComponent {
    public readonly title = input<string>();
    public readonly subtitle = input<string>();
    public readonly salaryRangeItems = input<SalaryRangeItem[] | null>();
}
